import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/use-cases", label: "Use Cases", testid: "nav-use-cases-link" },
  { to: "/#how-it-works", label: "How It Works", testid: "nav-how-it-works-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-200 ${
      isActive ? "text-indigo-600" : "text-slate-600 hover:text-slate-900"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/85 backdrop-blur-md" data-testid="site-navbar">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo-link" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links-desktop">
          {links.map((l) =>
            l.to.includes("#") ? (
              <Link key={l.to} to={l.to} data-testid={l.testid} className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900">
                {l.label}
              </Link>
            ) : (
              <NavLink key={l.to} to={l.to} data-testid={l.testid} className={linkClass} end={l.to === "/"}>
                {l.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/contact"
            data-testid="nav-demo-button"
            className="inline-flex items-center rounded-full bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-indigo-700"
          >
            Book a Demo
          </Link>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100 md:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white px-4 pb-6 pt-3 md:hidden" data-testid="nav-mobile-drawer">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-base font-medium text-slate-700 transition-colors hover:bg-slate-50 hover:text-indigo-600"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-demo-button-mobile"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center rounded-full bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700"
            >
              Book a Demo
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
